import { jsx as _jsx } from "react/jsx-runtime";
import './style.scss';
const TaskAnswerButton = ({ content, isSelected, answerId, onAnswerClick, disabled, }) => {
    return (_jsx("button", { className: `task-answer-button${isSelected ? ' selected' : ''}`, onClick: () => {
            onAnswerClick(answerId);
        }, disabled: disabled, children: _jsx("span", { className: "button-text", children: content }) }));
};
export default TaskAnswerButton;
